export function _reduceLazy(array, lazy, indexed) {
    var newArray = [];
    for (var index = 0; index < array.length; index++) {
        var item = array[index];
        var result = indexed ? lazy(item, index, array) : lazy(item);
        if (result.hasMany === true) {
            newArray.push.apply(newArray, result.next);
        }
        else if (result.hasNext) {
            newArray.push(result.next);
        }
    }
    return newArray;
}
